module.exports = __webpack_public_path__ + "img/sld_dcdb_t1_b1.c56db9e2.svg";